var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5002 12C23.5002 16.1421 20.1423 19.5 16.0002 19.5C11.858 19.5 8.50016 16.1421 8.50016 12C8.50016 7.85786 11.858 4.5 16.0002 4.5C20.1423 4.5 23.5002 7.85786 23.5002 12ZM19.687 20.2126C22.8192 18.8043 25.0002 15.6569 25.0002 12C25.0002 7.02944 20.9707 3 16.0002 3C11.0296 3 7.00016 7.02944 7.00016 12C7.00016 15.6569 9.18114 18.8043 12.3133 20.2126C6.88526 21.6115 3.49017 25.8429 2.32934 28.1646C2.1441 28.5351 2.29427 28.9856 2.66475 29.1708C3.03524 29.3561 3.48574 29.2059 3.67098 28.8354C4.93305 26.3113 9.19055 21.25 16.0002 21.25C22.8098 21.25 27.0673 26.3113 28.3293 28.8354C28.5146 29.2059 28.9651 29.3561 29.3356 29.1708C29.7061 28.9856 29.8562 28.5351 29.671 28.1646C28.5102 25.8429 25.1151 21.6115 19.687 20.2126Z",
    fill: "#0A7CC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.08edb3dcc621978c5ef9221c243b8125.svg";
export { ForwardRef as ReactComponent };